var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AddOperation, DeltaUpdateOperation, SchemaObject, SignalOperation, UpdateOperation } from '@augloop/types-core';
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
var supportedOperationSet = new Set([
    AddOperation.getTypeName(),
    UpdateOperation.getTypeName(),
    SignalOperation.getTypeName(),
    DeltaUpdateOperation.getTypeName()
]);
var percentageOfApplyContextIdOnOperationsLogs = 0.5;
var ContextIdManager = /** @class */ (function () {
    // TODO: Remove ChangeGate('ContextIdV2')
    function ContextIdManager(runtimeKind, changeGate) {
        if (changeGate === void 0) { changeGate = false; }
        this.collectionScopeTypesOnJoinWorkflows = new Set();
        this.updatesByScopeItemPath = new Map();
        this.runtimeKind = runtimeKind;
        this.pendingId = "".concat(runtimeKind, "0");
        this.contextIdTracker = new ContextIdTracker(runtimeKind);
        this.changeGate = changeGate;
    }
    ContextIdManager.prototype.getRuntimeKind = function () {
        return this.runtimeKind;
    };
    ContextIdManager.prototype.setActiveScopeType = function (collectionScopeType) {
        this.collectionScopeTypesOnJoinWorkflows.add(collectionScopeType);
    };
    ContextIdManager.prototype.applyContextIdOnOperations = function (ops) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e;
        // TODO: Remove ChangeGate('ContextIdV2')
        if (this.changeGate) {
            try {
                for (var ops_1 = __values(ops), ops_1_1 = ops_1.next(); !ops_1_1.done; ops_1_1 = ops_1.next()) {
                    var op = ops_1_1.value;
                    var opType = SchemaObject.getTypeNameFor(op);
                    if (!this.isSupportedOperation(opType)) {
                        continue;
                    }
                    try {
                        for (var _f = (e_2 = void 0, __values(op.items)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var item = _g.value;
                            var logOp = undefined;
                            if (Math.random() * 100 <= percentageOfApplyContextIdOnOperationsLogs) {
                                logOp = new LogOperation({ operationName: 'ApplyContextIdOnOperations', success: true }).start();
                            }
                            if (!item.contextId) {
                                // contextId look like: '' (no contextId)
                                // contextId will look like: S1 (root item)
                                var contextId = this.contextIdTracker.addRoot();
                                item.contextId = contextId;
                                this.tryLogMessage(logOp, "New root idem, giving a new root contextId: ".concat(item.id, " ").concat(item.contextId));
                                continue;
                            }
                            // Check last key
                            var keys = item.contextId.split('.');
                            var lastId = keys.splice(keys.length - 1)[0];
                            if (lastId === this.pendingId) {
                                // contextId looks like: S1.S0
                                // contextId will look like: S1.S2 (child item with correct count)
                                var newId = this.contextIdTracker.addChild(keys.join('.'));
                                item.contextId = newId;
                                this.tryLogMessage(logOp, "Item from workflow, adding new id to contextId: ".concat(this.runtimeKind, " ").concat(item.id, " ").concat(item.contextId));
                            }
                            else if (lastId[0] !== this.runtimeKind) {
                                // contextId looks like: C1
                                // contextId will looks like: C1 (keep the same, don't change because came from other runtime)
                                this.tryLogMessage(logOp, "Item from another runtime (".concat(lastId[0], "), keeping the same: ").concat(item.id, " ").concat(item.contextId));
                            }
                            else {
                                // contextId looks like: S1.S2
                                // contextId will looks like: S1.S2
                                // Error: we should not get a complete contextId from the same enviroment (it can only be generated by a workflow, and so have a pending id)
                                this.tryLogMessage(logOp, "Item from the same runtime (".concat(lastId[0], ") with complete contextId: ").concat(item.id, " ").concat(item.contextId), false);
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (ops_1_1 && !ops_1_1.done && (_a = ops_1.return)) _a.call(ops_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return;
        }
        try {
            for (var ops_2 = __values(ops), ops_2_1 = ops_2.next(); !ops_2_1.done; ops_2_1 = ops_2.next()) {
                var op = ops_2_1.value;
                var opType = SchemaObject.getTypeNameFor(op);
                if (!this.isSupportedOperation(opType)) {
                    continue;
                }
                try {
                    for (var _h = (e_4 = void 0, __values(op.items)), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        var logOp = undefined;
                        if (Math.random() * 100 <= percentageOfApplyContextIdOnOperationsLogs) {
                            logOp = new LogOperation({ operationName: 'ApplyContextIdOnOperations', success: true }).start();
                        }
                        // If the item already has a contextId keep it because it was
                        // piped from previous items
                        if (item.contextId) {
                            this.tryLogMessage(logOp, "Item of id: ".concat(item.id, " already has a contextId ").concat(item.contextId));
                        }
                        else {
                            var copyItemWithPath = __assign({ parentPath: op.parentPath }, item);
                            if (opType === DeltaUpdateOperation.getTypeName()) {
                                // TextTileDelta have id equal to the related TextTile, and the parentPath includes the TextTile id.
                                var tileCopyItemWithPath = __assign(__assign({}, item), { parentPath: op.parentPath.slice(0, -1) });
                                // Here we create a new contextId if we a TextTile related to this Delta.
                                if (this.updatesByScopeItemPath.has(this.makeItemPathStr(tileCopyItemWithPath))) {
                                    item.contextId = this.getNewContextId(tileCopyItemWithPath);
                                    this.tryLogMessage(logOp, "DeltaUpdateOperation ".concat(item.id, " already has a related TextTile, its new contextId is ").concat(item.contextId));
                                }
                                else {
                                    this.tryLogMessage(logOp, "DeltaUpdateOperation ".concat(item.id, " don't have a related TextTile with contextId"));
                                }
                                continue;
                            }
                            // Check if this item can be a scope item of any active join workflow
                            if (this.isScopeTypeOfAnyJoinWorkflow(item.body)) {
                                item.contextId = this.getNewContextId(copyItemWithPath);
                                this.tryLogMessage(logOp, "Item of id: ".concat(item.id, " is scope item of a join and its contextId is ").concat(item.contextId));
                            }
                            else {
                                // The item can be under a scope item that already has ContextId, so we must
                                // pipe it from the parent scope item that has the contextId
                                var itemPath = this.makeItemPathStr(copyItemWithPath);
                                try {
                                    for (var _k = (e_5 = void 0, __values(this.updatesByScopeItemPath.keys())), _l = _k.next(); !_l.done; _l = _k.next()) {
                                        var scopeItemPath = _l.value;
                                        if (itemPath.indexOf(scopeItemPath) >= 0) {
                                            item.contextId = this.getContextId(scopeItemPath);
                                            this.tryLogMessage(logOp, "Item of id: ".concat(item.id, " is not scope item of a join and its contextId is ").concat(item.contextId));
                                        }
                                    }
                                }
                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                finally {
                                    try {
                                        if (_l && !_l.done && (_e = _k.return)) _e.call(_k);
                                    }
                                    finally { if (e_5) throw e_5.error; }
                                }
                                if (!item.contextId) {
                                    this.tryLogMessage(logOp, "Item of id: ".concat(item.id, " does not belong to any join workflow execution"));
                                }
                            }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (ops_2_1 && !ops_2_1.done && (_c = ops_2.return)) _c.call(ops_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    ContextIdManager.prototype.getNewContextId = function (scopeItem) {
        var scopeItemPath = this.makeItemPathStr(scopeItem);
        var oldUpdateCount = this.updatesByScopeItemPath.get(scopeItemPath) || 0;
        this.updatesByScopeItemPath.set(scopeItemPath, oldUpdateCount + 1);
        return this.getContextId(scopeItemPath);
    };
    ContextIdManager.prototype.isSupportedOperation = function (operationType) {
        return supportedOperationSet.has(operationType);
    };
    ContextIdManager.prototype.isScopeTypeOfAnyJoinWorkflow = function (obj) {
        var scopeTypesOfJoins = __spreadArray([], __read(this.collectionScopeTypesOnJoinWorkflows), false);
        return scopeTypesOfJoins.length === 0 ? false : SchemaObject.matchesTypesFor(obj, scopeTypesOfJoins);
    };
    ContextIdManager.prototype.makeItemPathStr = function (item) {
        return __spreadArray(__spreadArray([], __read(item.parentPath), false), [item.id], false).join('/');
    };
    ContextIdManager.prototype.getContextId = function (scopeItemPath) {
        return scopeItemPath + '@' + this.updatesByScopeItemPath.get(scopeItemPath);
    };
    ContextIdManager.prototype.tryLogMessage = function (logOp, message, success) {
        if (success === void 0) { success = true; }
        if (logOp) {
            logOp.success = success;
            logOp.resultDescription = message;
            Log.verbose(0x1f6e1759 /* tag_5173z */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    return ContextIdManager;
}());
export { ContextIdManager };
var ContextIdTracker = /** @class */ (function () {
    function ContextIdTracker(runtimeKind) {
        this.rootCount = 0;
        this.children = new Map();
        this.runtimeKind = runtimeKind;
    }
    ContextIdTracker.prototype.addRoot = function () {
        this.rootCount++;
        var nodeKey = this.buildNodeKey(this.rootCount);
        this.increaseChildCount(nodeKey);
        return nodeKey;
    };
    ContextIdTracker.prototype.addChild = function (parentKey) {
        if (!this.children.has(parentKey)) {
            this.increaseChildCount(parentKey);
        }
        var parentChildrenCount = this.children.get(parentKey);
        var key = this.appendNodeKey(parentKey, this.buildNodeKey(parentChildrenCount + 1));
        this.increaseChildCount(parentKey);
        this.increaseChildCount(key);
        return key;
    };
    ContextIdTracker.prototype.increaseChildCount = function (key) {
        try {
            this.children.set(key, this.children.has(key) ? this.children.get(key) + 1 : 0);
        }
        catch (error) {
            // TODO 6138147: Clear entries on ContextIdTracker map
            var logOp = new LogOperation({ operationName: 'ContextIdTracker', resultDescription: "key: ".concat(key, ", rootCount: ").concat(this.rootCount, ", children map size: ").concat(this.children.size, ". Error: ").concat(error), success: true }).start();
            Log.error(0x1f407861 /* tag_5qh77 */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    ContextIdTracker.prototype.buildNodeKey = function (count, id) {
        if (id === void 0) { id = this.runtimeKind; }
        return id + count.toString();
    };
    ContextIdTracker.prototype.appendNodeKey = function (parentKey, key) {
        return parentKey + '.' + key;
    };
    return ContextIdTracker;
}());
export { ContextIdTracker };
//# sourceMappingURL=context-id-manager.js.map